const components = {
  ApplicationEditor: () => import('@/iam/components/Applications/ApplicationEditor'),
  Applications: () => import('@/iam/components/Applications/Applications'),
  AuthenticationProviderEditor: () => import('@/iam/components/AuthenticationProvider/AuthenticationProviderEditor'),
  AuthenticationProviders: () => import('@/iam/components/AuthenticationProvider/AuthenticationProviders'),
  Authorize: () => import('@/iam/components/Authorize'),
  GroupEditor: () => import('@/iam/components/Groups/GroupEditor'),
  Groups: () => import('@/iam/components/Groups/Groups'),
  Overview: () => import('@/iam/components/Overview'),
  RoleEditor: () => import('@/iam/components/Roles/RoleEditor'),
  Roles: () => import('@/iam/components/Roles/Roles'),
  ServiceAccountEditor: () => import('@/iam/components/ServiceAccounts/ServiceAccountEditor'),
  ServiceAccounts: () => import('@/iam/components/ServiceAccounts/ServiceAccounts'),
  Settings: () => import('@/iam/components/Settings/Settings'),
  UserEditor: () => import('@/iam/components/Users/UserEditor'),
  Users: () => import('@/iam/components/Users/Users'),
  UserInvite: () => import('@/iam/components/Users/Invite'),
  Authentication: () => import('@/iam/components/AuthenticationSettings/Authentication'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId')
}

const routes = [
  {
    path: '/',
    name: 'IAM',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'IAM - Overview',
    display_name: 'searchbar.items.iam.overview.display_name',
    description: 'searchbar.items.iam.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },

  {
    path: '/:dataplantId/oauth/authorize',
    name: 'Authorize',
    component: components.Authorize,
    meta: {
      analytics: { category: 'authentication' },
      fullscreen: true
    }
  },

  {
    path: '/:dataplantId/authentication_settings',
    name: 'IAM - Authentication',
    component: components.Authentication,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Authentication - ${parent(route, false)}`,
      ready: ['iam_authentication_providers']
    }
  },

  {
    path: '/:dataplantId/authentication_settings/sso_provider',
    name: 'IAM - SSO Provider Configuration',
    component: components.AuthenticationProviderEditor,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Authentication - ${parent(route, false)}`,
      ready: ['iam_authentication_providers']
    }
  },

  {
    path: '/:dataplantId/authentication_settings/sso_provider/:id',
    name: 'IAM - Edit SSO Provider Configuration',
    component: components.AuthenticationProviderEditor,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Authentication - ${parent(route, false)}`,
      ready: ['iam_authentication_providers']
    }
  },

  {
    path: '/:dataplantId/applications',
    name: 'IAM - Applications',
    display_name: 'searchbar.items.iam.applications.display_name',
    description: 'searchbar.items.iam.applications.description',
    searchable: true,
    component: components.Applications,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Applications - ${parent(route, false)}`,
      ready: ['iam_applications']
    }
  },
  {
    path: '/:dataplantId/application/:id?',
    name: 'IAM - Edit Application',
    component: components.ApplicationEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Application - ${parent(route, false)}`,
      ready: ['iam_applications']
    }
  },
  {
    path: '/:dataplantId/authentication_providers',
    name: 'IAM - Authentication Provider',
    display_name: 'searchbar.items.iam.auth_providers.display_name',
    description: 'searchbar.items.iam.auth_providers.description',
    searchable: true,
    component: components.AuthenticationProviders,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Authentication Providers - ${parent(route, false)}`,
      ready: ['iam_authentication_providers']
    }
  },
  {
    path: '/:dataplantId/authentication_provider/:id?',
    name: 'IAM - Edit Authentication Provider',
    component: components.AuthenticationProviderEditor,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Authentication Provider - ${parent(route, false)}`,
      ready: ['iam_authentication_providers']
    }
  },
  {
    path: '/:dataplantId/users',
    name: 'Users',
    display_name: 'searchbar.items.iam.users.display_name',
    description: 'searchbar.items.iam.users.description',
    searchable: true,
    component: components.Users,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Users - ${parent(route, false)}`,
      ready: ['iam_users']
    }
  },
  {
    path: '/:dataplantId/user/:id?',
    name: 'IAM - Edit User',
    component: components.UserEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `User - ${parent(route, false)}`,
      ready: ['iam_users']
    }
  },
  {
    path: '/:dataplantId/invite',
    name: 'IAM - Invite User',
    component: components.UserInvite,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `User - ${parent(route, false)}`,
      ready: ['iam_users']
    }
  },
  {
    path: '/:dataplantId/settings',
    name: 'IAM - Settings',
    display_name: 'searchbar.items.iam.settings.display_name',
    description: 'searchbar.items.iam.settings.description',
    searchable: true,
    component: components.Settings,
    meta: {
      analytics: { category: 'settings' },
      title: (route, parent) => `Settings - ${parent(route)}`,
      ready: ['iam_configuration', 'iam_mails']
    }
  },
  {
    path: '/:dataplantId/groups',
    name: 'IAM - Groups',
    display_name: 'searchbar.items.iam.groups.display_name',
    description: 'searchbar.items.iam.groups.description',
    searchable: true,
    component: components.Groups,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Groups - ${parent(route, false)}`,
      ready: ['iam_groups']
    }
  },
  {
    path: '/:dataplantId/group/:id?',
    name: 'IAM - Edit Group',
    component: components.GroupEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Group - ${parent(route, false)}`,
      ready: ['iam_groups']
    }
  },
  {
    path: '/:dataplantId/roles',
    name: 'IAM - Roles',
    display_name: 'searchbar.items.iam.roles.display_name',
    description: 'searchbar.items.iam.roles.description',
    searchable: true,
    component: components.Roles,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Roles - ${parent(route, false)}`,
      ready: ['iam_roles', 'iam_users']
    }
  },
  {
    path: '/:dataplantId/role/:id?',
    name: 'IAM - Edit Role',
    component: components.RoleEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Role - ${parent(route, false)}`,
      ready: ['iam_roles']
    }
  },
  {
    path: '/:dataplantId/service_accounts',
    name: 'IAM - Service Accounts',
    display_name: 'searchbar.items.iam.service_accounts.display_name',
    description: 'searchbar.items.iam.service_accounts.description',
    searchable: true,
    component: components.ServiceAccounts,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Service Accounts - ${parent(route, false)}`,
      ready: ['iam_service_accounts']
    }
  },
  {
    path: '/:dataplantId/service_account/:id?',
    name: 'IAM - Edit Service Account',
    component: components.ServiceAccountEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Service Account - ${parent(route, false)}`,
      ready: ['iam_service_accounts']
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'IAM' }
  }
]

export const basePath = 'iam/'
export default routes
